// A small Markdown renderer for Claude's answers (Ask your data): paragraphs, **bold**, bullet and numbered
// lists, and tables. Builds React elements only (no HTML injection), so nothing in an answer can run.

function inline(text, key) {
  const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => (p.startsWith("**") && p.endsWith("**") && p.length > 4
    ? <strong key={`${key}-${i}`} className="text-zinc-50">{p.slice(2, -2)}</strong>
    : <span key={`${key}-${i}`}>{p}</span>));
}

const cells = (line) => line.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").map((c) => c.trim());
const isRule = (line) => /^\s*\|?\s*:?-{2,}/.test(line);

export default function SimpleMarkdown({ text }) {
  const lines = String(text || "").split("\n");
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (!line.trim()) { i++; continue; }
    if (line.trim().startsWith("|") && i + 1 < lines.length && isRule(lines[i + 1])) {
      const head = cells(line);
      const rows = [];
      i += 2;
      while (i < lines.length && lines[i].trim().startsWith("|")) { rows.push(cells(lines[i])); i++; }
      out.push(
        <div key={`t${i}`} className="overflow-x-auto my-3">
          <table className="text-sm border-collapse">
            <thead><tr>{head.map((h, j) => <th key={j} className="text-left font-medium text-zinc-400 border-b border-[#2a2a2a] px-3 py-1.5">{inline(h, `h${j}`)}</th>)}</tr></thead>
            <tbody>{rows.map((r, ri) => (
              <tr key={ri} className="border-b border-[#1a1a1a] last:border-0">
                {r.map((c, j) => <td key={j} className={`px-3 py-1.5 text-zinc-200 ${/^[\d.,%₹$ -]+$|^(INR|LKR|AED)/.test(c) ? "text-right tabular-nums" : ""}`}>{inline(c, `c${ri}${j}`)}</td>)}
              </tr>
            ))}</tbody>
          </table>
        </div>,
      );
      continue;
    }
    if (/^\s*([-*]|\d+\.)\s+/.test(line)) {
      const ordered = /^\s*\d+\./.test(line);
      const items = [];
      while (i < lines.length && /^\s*([-*]|\d+\.)\s+/.test(lines[i])) { items.push(lines[i].replace(/^\s*([-*]|\d+\.)\s+/, "")); i++; }
      const List = ordered ? "ol" : "ul";
      out.push(
        <List key={`l${i}`} className={`${ordered ? "list-decimal" : "list-disc"} pl-5 my-2 space-y-1 text-zinc-200`}>
          {items.map((it, j) => <li key={j}>{inline(it, `li${i}${j}`)}</li>)}
        </List>,
      );
      continue;
    }
    if (/^#{1,4}\s/.test(line)) {
      out.push(<div key={`h${i}`} className="font-semibold text-zinc-50 mt-4 mb-1">{inline(line.replace(/^#+\s*/, ""), `hd${i}`)}</div>);
      i++;
      continue;
    }
    out.push(<p key={`p${i}`} className="my-2 text-zinc-200 leading-relaxed">{inline(line, `p${i}`)}</p>);
    i++;
  }
  return <div data-testid="simple-markdown">{out}</div>;
}
